import React from 'react'
import styled from 'react-emotion'
import { SUI } from 'shared/ui'
import themeVars from 'ui_theme/site/globals/site.variables'
import GlobalNav from '../'

const WithGlobalNavContainer = styled('div')`
  display: flex;
  height: 100%;
  background-color: ${themeVars.brightSuperDark};
  overflow: hidden;

  @media print {
    display: block;
  }
`

const ContentContainer = styled('div')`
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  flex-grow: 1;
  background-color: ${themeVars.groovy};
  overflow: hidden;
  z-index: 2;

  @media print {
    display: block;
  }
`

const LeftSidebarContainer = styled('div')`
  position: relative;
  width: ${({ isCollapsed }) => (isCollapsed ? 0 : '220px')};
  min-height: 100%;
  transition: width 150ms;
  box-shadow: inset 0 0 4px 0 rgba(0, 0, 0, 0.3);
  @media only screen and (max-width: ${themeVars.mediumMonitorBreakpoint}) {
    width: ${({ isCollapsed }) => (isCollapsed ? 0 : '210px')};
  }
`
const LeftSidebarHolder = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 220px;
  @media only screen and (max-width: ${themeVars.mediumMonitorBreakpoint}) {
    width: 210px;
  }
`

const ChildrenContainer = styled('div')`
  width: 100%;
  min-width: 0;
  background-color: ${themeVars.brightSuperDark};
  overflow: hidden auto;
  border-left: ${({ isLeftSidebarCollapsed }) =>
    isLeftSidebarCollapsed ? `1px solid ${themeVars.ultraDust}` : 0};
  z-index: 1;
`

const MainAreaContainer = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-width: 0;

  @media print {
    display: block;
  }
`

export default function WithGlobalNav({
  active,
  leftSidebar,
  leftSidebarBg,
  isLeftSidebarCollapsed,
  children,
  topContent,
}) {
  return (
    <WithGlobalNavContainer>
      <GlobalNav active={active} />
      <MainAreaContainer>
        {topContent}
        <ContentContainer
          leftSidebarBg={leftSidebarBg}
          isLeftSidebarCollapsed={isLeftSidebarCollapsed}
        >
          {leftSidebar && (
            <SUI>
              <LeftSidebarContainer isCollapsed={isLeftSidebarCollapsed}>
                <LeftSidebarHolder>{leftSidebar}</LeftSidebarHolder>
              </LeftSidebarContainer>
            </SUI>
          )}
          <ChildrenContainer isLeftSidebarCollapsed={isLeftSidebarCollapsed}>
            {children}
          </ChildrenContainer>
        </ContentContainer>
      </MainAreaContainer>
    </WithGlobalNavContainer>
  )
}
